import {
    GRID_ACTIONS_CELL_ATTR,
    GRID_TEXT_CLAMP_CLASS
} from '../../../utils/gridColumns';

// Data cells of the grid table body: not the checkbox column, not the row
// actions, and not a full-width row (no results) spanning them all.
const DATA_CELLS = [
    '& > tbody > tr > td',
    ':not(.MuiTableCell-paddingCheckbox)',
    `:not([${GRID_ACTIONS_CELL_ATTR}])`,
    ':not([colspan])'
].join('');

// sx of the grid table once the user has sized its columns (GridPageAbstract
// renders a <colgroup> with a width per data column alongside).
//
// The table keeps the automatic layout, so the checkbox and actions columns
// stay as wide as their content and need no width of their own. A body cell
// with `max-width: 0` contributes nothing to its column's minimum, so the
// column takes its <col> width — narrower than the content too, the overflow
// clipped. Head cells keep their minimum: a column never gets narrower than
// the longest word of its label, the label wrapping between words. Body text
// stays on one line, so narrowing a column never makes rows taller; text
// ends in an ellipsis — text straight in the cell (a phone, a related
// record's name) by the cell's own `text-overflow`, a Typography line by its
// own. `min-width: max-content` lets the table grow past its container when
// the columns add up to more (the scroll area pans), and when they add up to
// less the spare width goes to the only column without a width: the actions
// column at the right end.
export const sizedColumnsTableSx = {
    'minWidth': 'max-content',
    [DATA_CELLS]: {
        maxWidth: 0,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
    },
    [`${DATA_CELLS} > .MuiTypography-root`]: {
        display: 'block',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    },
    '& > thead > tr > th': {
        whiteSpace: 'normal'
    },
    // Text cells cap themselves while widths are natural; a sized column is
    // the cap now.
    [`& .${GRID_TEXT_CLAMP_CLASS}`]: {
        maxWidth: 'none'
    }
};
